import './style.scss';

export function details_block() {
    const block = document.querySelector('.details_block');
    if (!block) return;

}
